import { Injectable } from "@angular/core";
import { PsBillingCodes, DefaultService, PsMaterialBillingCodes } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PSCodeService {
    constructor(private powerSupplyService: DefaultService) {
        this.getPsBillingCodes();
    }

    getPsBillingCodes() {
        return this.powerSupplyService.getPsBillingCodes().pipe(map(result => result));
    }

    createPsCodedata(model: PsBillingCodes) {
        return this.powerSupplyService.createPsBillingCodes(model).pipe(map(result => result));
    }

    updatebilling(model: PsBillingCodes) {
        return this.powerSupplyService.updatePsBillingCodes(model).pipe(map(result => result));
    }

    deletebillingType(id: number) {
        return this.powerSupplyService.deletePsBillingCodes(id).pipe(map(result => result));
    }


    getmaterialType(){
        return this.powerSupplyService.getAllPsMaterialBillingCodes().pipe(map(result => result));
    }

    getchangematerialType(model){
        return this.powerSupplyService.getPsMaterialBillingCodes(model).pipe(map(result => result));
    }

}
